import { isDefined } from '@sgme/fp';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { TextWithPostValueValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';
import { camelCaseToWords } from 'utils/string';

export interface ProductSummaryTextWithPostValueFieldProps {
  node: TextWithPostValueValueDefinition;
}

export const ProductSummaryTextWithPostValueField: FC<ProductSummaryTextWithPostValueFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        {isDefined(data?.value) && (
          <FormattedMessage id={`field.${data.value}` as IntlKey} defaultMessage={data.value} />
        )}
        {isDefined(data?.postValue) && (
          <>
            {' ('}
            <FormattedMessage
              id={`productSummary.postValue.${data.postValue}` as IntlKey}
              defaultMessage={camelCaseToWords(data.postValue)}
            />
            {')'}
          </>
        )}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryTextWithPostValueField.displayName = 'ProductSummaryTextWithPostValueField';
